export default function Dash({ children }){ return children ?? <>&mdash;</> }